import { combineReducers } from 'redux';
import appState from './appState';
import authState from './authState';
import roleManager from './roleManager';
import orgModal from './orgModal';
import updateMobileState from './updateMobileState';
import updateUnsavedData from './updateUnsavedData';

const commonBus = combineReducers({
  appState,
  authState,
  roleManager,
  orgModal,
  updateMobileState,
  updateUnsavedData
})

export default commonBus
